<template>
  <div>
    <v-text-field v-model="local.subject" label="Assunto" outlined dense @input="emitChange" />
    <v-btn small text class="mb-2" @click="insertVariable">Inserir {{ variableLabel }}</v-btn>
    <v-btn small text class="mb-2" :loading="uploading" @click="$refs.file.click()">
      Inserir imagem
    </v-btn>
    <input ref="file" type="file" accept="image/*" hidden @change="onFile" />
    <div :id="holder" />
  </div>
</template>

<script>
import Editor from "@toast-ui/editor";
import "@toast-ui/editor/dist/i18n/pt-br";
import "@toast-ui/editor/dist/toastui-editor.css";
import "@toast-ui/editor/dist/theme/toastui-editor-dark.css";

const VARIABLE = "{{user.firstName}}";

export default {
  props: {
    value: { type: Object, default: () => ({}) },
    upload: { type: Function, required: true },
  },
  data() {
    return {
      variableLabel: VARIABLE,
      holder: `campaign-email-${Math.random().toString(36).slice(2)}`,
      editor: null,
      uploading: false,
      silent: false,
      local: {
        subject: this.value?.subject || "",
        html: this.value?.html || "",
      },
    };
  },
  mounted() {
    this.editor = new Editor({
      el: document.getElementById(this.holder),
      language: "pt-br",
      usageStatistics: false,
      hideModeSwitch: true,
      initialEditType: "wysiwyg",
      minHeight: "240px",
      theme: this.$vuetify.theme.dark ? "dark" : "default",
      initialValue: " ",
      events: {
        change: () => {
          if (this.silent || !this.editor) return;
          this.local.html = this.editor.getHTML();
          this.emitChange();
        },
      },
    });
    this.silent = true;
    this.editor.setHTML(this.local.html || "");
    this.silent = false;
  },
  beforeDestroy() {
    if (this.editor) this.editor.destroy();
  },
  methods: {
    emitChange() {
      this.$emit("input", { subject: this.local.subject, html: this.local.html });
    },
    insertVariable() {
      if (!this.editor) return;
      this.editor.insertText(VARIABLE);
    },
    async onFile(event) {
      const file = event.target.files && event.target.files[0];
      event.target.value = "";
      if (!file || !this.editor) return;
      this.uploading = true;
      try {
        const result = await this.upload(file);
        const html = `${this.editor.getHTML()}<p><img src="${result.url}" alt="" /></p>`;
        this.silent = true;
        this.editor.setHTML(html);
        this.silent = false;
        this.local.html = html;
        this.emitChange();
      } finally {
        this.uploading = false;
      }
    },
  },
};
</script>
